import { Component, Inject } from '@angular/core';
import { Recipient } from '../../../interfaces/recipient';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-dismiss-max-mismatches-warning-dialog',
  imports: [MatDialogModule, MatDialogContent, MatButtonModule, MatFormFieldModule, MatInputModule, CommonModule, FormsModule],
  templateUrl: './dismiss-max-mismatches-warning-dialog.component.html',
  styleUrl: './dismiss-max-mismatches-warning-dialog.component.scss'
})
export class DismissMaxMismatchesWarningDialogComponent {
  constructor(
    private readonly ref: MatDialogRef<DismissMaxMismatchesWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { recipient: Recipient }
  ) {
    this.recipient = data.recipient;
  }

  recipient!: Recipient;
  dismissalReason: string = '';

  isFormValid(): boolean {
    return this.dismissalReason.trim() !== '';
  }

  cancel(): void {
    this.ref.close(false);
  }

  dismiss(): void {
    if (!this.isFormValid()) return;
    this.ref.close({ confirmed: true, reason: this.dismissalReason });
  }
}
